import React from 'react';
import { IconStopRecording } from '../../../base/icons';

import AbstractRecordButton, {
    _mapStateToProps as _abstractMapStateToProps,
    type Props as _Props
} from './AbstractRecordButton';

export const _mapStateToProps = _abstractMapStateToProps
export type Props = _Props

export default class RPC_AbstractRecordButton extends AbstractRecordButton {
    toggledIcon = IconStopRecording
}